var init = function() {
	var stars = document.querySelectorAll('.survey .stars span');
	var dropdown = document.getElementById('surveyForm:starsDropdown');
	var	star;
	
	function starOnClick(event) {
		var clickedStar = event.currentTarget;
		var isActive = true;
		var clickedStarIndex;
		
		// Loop through stars and fill them in appropriately
		// Also find clicked star's index
		for (var i = 0; i < stars.length; i++) {
			var star = stars[i];
			if(isActive) {
				star.className = 'isActive';
				if (star === clickedStar) {
					isActive = false;
					clickedStarIndex = i;
				}
			} else {
				star.className = '';
			}
		}
		
		// Set the value of the dropdown
		if (dropdown != null) {
			dropdown.value = clickedStarIndex + 1;
		}
	}
	
	for (var i = 0; i < stars.length; i++) {
		star = stars[i];
		if (i < dropdown.value) {
			star.className = 'isActive';
		}
		star.addEventListener('click', starOnClick, false);
	}
}

module.exports = {
	init : init
};